/**
 * Groups management's place in the navigation. Under ui_uplift = next the group list belongs
 * to People (docs/design/MODULE_MAPS.md: People › Groups); the group finder, curriculum,
 * health and messages stay in Ministry. The classic layout keeps all of /groups in Ministry.
 */
export const GROUP_MANAGEMENT_PATH = "/groups/management";

/** The /groups routes that stay in Ministry once the management list moves to People. */
export const MINISTRY_GROUP_PATHS = [
  "/groups/finder",
  "/groups/curriculum",
  "/groups/health",
  "/groups/communication",
  "/groups/messages",
] as const;

/**
 * Sidebar prefixes match with startsWith, so Ministry's "/groups" would also claim the
 * management list: it gives way to the group routes that stay in Ministry, and People gains
 * /groups/management. Items without either are returned as they are.
 */
export function placeGroupManagementUnderPeople<T extends { href?: string; matchPrefixes?: string[] }>(items: T[]): T[] {
  return items.map((item) => {
    if (item.href === "/ministry" && item.matchPrefixes?.includes("/groups")) {
      return {
        ...item,
        matchPrefixes: item.matchPrefixes.flatMap((prefix) => (prefix === "/groups" ? [...MINISTRY_GROUP_PATHS] : [prefix])),
      };
    }
    if (item.href === "/people" && item.matchPrefixes && !item.matchPrefixes.includes(GROUP_MANAGEMENT_PATH)) {
      return { ...item, matchPrefixes: [...item.matchPrefixes, GROUP_MANAGEMENT_PATH] };
    }
    return item;
  });
}
